<template>
    <div class="about">
        <div class="about1">
            <div class="texts">
                <div class="t1-title">{{text1}}<div class="row1-title-text2">{{text2}}</div></div>
                <div class="t2">赋能支持远程开发、远程剪辑、远程办公及远程桌面等多种场景。</div>
                <div class="row1-btn" @click="jumpDownload()">立即体验</div>
            </div>
        </div>
        <div class="about2">
            <div class="texts">
                <div class="texts-c">
                    <div class="t1">关于我们</div>
                    <div class="t2-jianbian"></div>
                    <div class="t3">拓维网络深圳有限公司成立于2017年，公司总部位于粤港澳大湾区的深圳，是一家国家高新技术企业和专精特新企业。核心成员均来自知名互联网公司，工作经验平均超10年以上，具有丰富的项目管理及运营经验。</div>
                    <div class="t3 t4">拓维网络公司围绕产品赋能、技术授权为发展方向，帮助企业远程办公、家庭远程打印、政企安全连接传输提供产品解决方案和技术解决方案。</div>
                    <div class="t3 t4">经过多年发展，公司产品和技术受到了用户和客户的喜欢，合作伙伴涵盖私有云行业、路由器行业、视频行业、运营商、监控行业等。踏实而又富于激情的团队，对待客户及用户需求具备快速洞察力和响应力，我们的发展宗旨是成长为一家领先的远程管理技术服务商。</div>
                </div>
            </div>
        </div>
        <div class="about3">
            <div class="texts">
                <div class="t1">企业荣誉</div>
                <div class="t2 t2a">
                    <div class="t3">2021 <span class="year">年</span></div>
                    <div class="t4">国家高新企业</div>
                </div>
                <div class="t2 t2b">
                    <div class="t3">2021 <span class="year">年</span></div>
                    <div class="t4">国家鼓励的软件企业</div>
                </div>
                <div class="t2 t2c">
                    <div class="t3">2022 <span class="year">年</span></div>
                    <div class="t4">创新型中小企业</div>
                </div>
                <div class="t2 t2d">
                    <div class="t3">2023 <span class="year">年</span></div>
                    <div class="t4">专精特新企业</div>
                </div>
            </div>
        </div>

        <div class="about4">
            <div class="t1">合作伙伴</div>
            <div class="t2">我们的团队得到了这样的优秀公司的支持</div>
            <div class="row2-slide-a">
                <div class="row2-item" :style="{ '--count': 1 }">
                    <div class="row2-item-in row2-item1"></div>
                </div>
                <div class="row2-item" :style="{ '--count': 2 }">
                    <div class="row2-item-in row2-item2"></div>
                </div>
                <div class="row2-item" :style="{ '--count': 3 }">
                    <div class="row2-item-in row2-item3"></div>
                </div>
                <div class="row2-item" :style="{ '--count': 4 }">
                    <div class="row2-item-in row2-item4"></div>
                </div>
                <div class="row2-item" :style="{ '--count': 5 }">
                    <div class="row2-item-in row2-item5"></div>
                </div>
                <div class="row2-item" :style="{ '--count': 6 }">
                    <div class="row2-item-in row2-item6"></div>
                </div>
                <div class="row2-item" :style="{ '--count': 7 }">
                    <div class="row2-item-in row2-item7"></div>
                </div>
                <div class="row2-item" :style="{ '--count': 8 }">
                    <div class="row2-item-in row2-item8"></div>
                </div>
                <div class="row2-item" :style="{ '--count': 9 }">
                    <div class="row2-item-in row2-item9"></div>
                </div>
                <div class="row2-item" :style="{ '--count': 10 }">
                    <div class="row2-item-in row2-item10"></div>
                </div>
            </div>
            <div class="row2-slide-b">
                <div class="row2-item-b" :style="{ '--count': 1 }">
                    <div class="row2-item-b-in row2-b-item1"></div>
                </div>
                <div class="row2-item-b" :style="{ '--count': 2 }">
                    <div class="row2-item-b-in row2-b-item2"></div>
                </div>
                <div class="row2-item-b" :style="{ '--count': 3 }">
                    <div class="row2-item-b-in row2-b-item3"></div>
                </div>
                <div class="row2-item-b" :style="{ '--count': 4 }">
                    <div class="row2-item-b-in row2-b-item4"></div>
                </div>
                <div class="row2-item-b" :style="{ '--count': 5 }">
                    <div class="row2-item-b-in row2-b-item5"></div>
                </div>
                <div class="row2-item-b" :style="{ '--count': 6 }">
                    <div class="row2-item-b-in row2-b-item6"></div>
                </div>
                <div class="row2-item-b" :style="{ '--count': 7 }">
                    <div class="row2-item-b-in row2-b-item7"></div>
                </div>
                <div class="row2-item-b" :style="{ '--count': 8 }">
                    <div class="row2-item-b-in row2-b-item8"></div>
                </div>
                <div class="row2-item-b" :style="{ '--count': 9 }">
                    <div class="row2-item-b-in row2-b-item9"></div>
                </div>
                <div class="row2-item-b" :style="{ '--count': 10 }">
                    <div class="row2-item-b-in row2-b-item10"></div>
                </div>
            </div>
        </div>
        <div class="about5">
            <div class="t1">联系我们</div>
            <div class="t2">
                <div class="about5-icon"></div>
                <div class="t2a">公司地址</div>
                <div class="t2b">深圳市南山区西丽街道创智云城A7-1608</div>
            </div>
            <div class="t2 t3" v-if="false">
                <div class="about5-icon about5-icon2"></div>
                <div class="t2a">咨询电话</div>
                <div class="t2b">0755-86607260</div>
            </div>
        </div>

        <Foot></Foot>
    </div>
</template>

<script>
    import Foot from "@/components/Foot.vue";

    export default {
        name: "About",
        components: {
            Foot,
        },
        data:function(){
            return {
                text1:"",
                text1b:"节点小宝",
                text1CharIndex:0,
                text2:"",
                text2b:"远程助手",
                text2CharIndex:0,
            }
        },
        methods:{
            jumpDownload: function () {
                this.$router.push({
                    path: "download",
                });
            },
            type:function(type){
                let _that = this;
                if(type == 1){
                    setTimeout(function(){
                        if(_that.text1CharIndex <  _that.text1b.length){
                            _that.text1 += _that.text1b.charAt(_that.text1CharIndex);
                            _that.text1CharIndex++;
                            _that.type(1);
                        }
                    }, 80);
                }else if(type == 2){
                    setTimeout(function(){
                        if(_that.text2CharIndex <  _that.text2b.length){
                            _that.text2 += _that.text2b.charAt(_that.text2CharIndex);
                            _that.text2CharIndex++;
                            _that.type(2);
                        }
                    }, 80);
                }

            },
        },
        mounted() {
            let _that = this;

            _that.type(1);
            setTimeout(function(){
                _that.type(2);
            }, 320);
        }
    }
</script>

<style lang="less">
.about{
    .about1{
        height: 500px;
        background-image: url("../assets/v4/a1.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        overflow: hidden;
        .texts{
            margin: 0 auto;
            margin-top: 168px;
            width: 1280px;
            .t1-title{
                width: 403px;
                height: 72px;
                font-size: 48px;
                font-weight: 900;
                text-align: left;

                .row1-title-text2{
                    margin-left: 8px;
                    display: inline-block;
                    background: linear-gradient(90deg, rgba(55, 114, 255, 1),rgba(170, 86, 255, 1) 36%,rgba(255, 104, 56, 1) 65%,rgba(255, 153, 36, 1) 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: rgba(0, 0, 0, 0);
                    width: 192px;
                }
            }
            .t2{
                margin-top: 12px;
                font-size: 20px;
                color: #17171B;
                line-height: 28px;
            }
            .row1-btn{
                margin-top: 45px;
                width: 160px;
                height: 48px;
                border-radius: 8px;
                background-color: #3772FF;
                line-height: 48px;
                font-size: 18px;
                font-weight: 500;
                text-align: center;
                color: #FFFFFF;
                cursor: pointer;
            }
            .row1-btn:hover{
                opacity: 0.9;
            }
        }

    }
    .about2{
        height: 600px;
        .texts{
            margin: 0 auto;
            width: 1280px;
            height: 100%;
            background-image: url("../assets/v4/a2.png");
            background-size: 600px 400px;
            background-repeat: no-repeat;
            background-position: left center;
            .texts-c{
                float: right;
                margin-top: 124px;
                width: 614px;
                .t1{
                    font-size: 30px;
                    font-weight: bold;
                    color: #17171B;
                    height: 42px;
                }
                .t2-jianbian{
                    margin-top: 20px;
                    width: 31px;
                    height: 4px;
                    border-radius: 3px;
                    background: linear-gradient(90deg, rgba(55, 114, 255, 1),rgba(170, 86, 255, 1) 36%,rgba(255, 104, 56, 1) 65%,rgba(255, 153, 36, 1) 100%);
                }
                .t3{
                    margin-top: 20px;
                    color: #57576C;
                    font-size: 16px;
                    line-height: 24px;
                }
                .t4{
                    margin-top: 26px;
                }
            }
        }

    }
    .about3 {
        height: 600px;
        background: linear-gradient(90deg, #ECECFF 0%, #F1EDFF 50%, #FFF4ED 100%);
        .texts {
            margin: 0 auto;
            height: 100%;
            overflow: hidden;
            text-align: center;

            .t1{
                margin-top: 66px;
                margin-bottom: 50px;
                font-size: 40px;
                font-weight: bold;
                color: #17171B;
                line-height: 58px;
                text-align: center;
            }
            .t2{
                display: inline-block;
                position: relative;
                margin: 0 13px;
                padding-left: 24px;
                width: 300px;
                height: 300px;
                border-radius: 10px;
                background: linear-gradient(180deg, rgba(230, 227, 255, 0.7) 0%, rgba(255, 255, 255, 0.7) 100%);
                box-sizing: border-box;
                border: 2px solid #FFFFFF;
                box-shadow: 0px 4px 30px 0px #E6E3FF;
                overflow: hidden;
                text-align: left;
                .t3{
                    margin-top: 220px;
                    color: #17171B;
                    line-height: 30px;
                    font-weight: 700;
                    font-size: 26px;
                    .year{
                        margin-left: -4px;
                        vertical-align: middle;
                        font-weight: 700;
                        font-size: 16px;
                    }
                }
                .t4{
                    margin-top: 8px;
                    font-size: 18px;
                    color: #17171B;
                    line-height: 20px;
                }
            }
            .t2::before{
                position: absolute;
                left: 0;
                top: 0;
                content: "";
                width: 100%;
                height: 200px;
                background-image: url("../assets/v4/a3.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
            }

            .t2b::before{
                background-image: url("../assets/v4/a4.png");
            }
            .t2c::before{
                background-image: url("../assets/v4/a5.png");
            }
            .t2d::before{
                background-image: url("../assets/v4/a6.png");
            }
        }
    }

    .about4{
        height: 500px;
        background: #FFFFFF;
        overflow: hidden;
        text-align: center;
        .t1{
            margin-top: 68px;
            font-size: 40px;
            font-weight: bold;
            color: #17171B;
            line-height: 58px;
            text-align: center;
        }
        .t2{
            margin-top: 12px;
            font-size: 16px;
            line-height: 22px;
            color: #57576C;
            text-align: center;
        }
        .row2-slide-a {
            --logo-width: 190px;
            --logo-width2: 200px;
            --logo-height: 72px;
            --logo-count: 10;
            --duration: 36s;
            width: 100%;
            margin-inline: auto;
            margin-top: 84px;
            position: relative;
            height: var(--logo-height);
            overflow: hidden;

            @keyframes slide {
                to {
                    right: calc(var(--logo-width) * -1);
                }
            }
            .row2-item {
                position: absolute;
                right: calc(var(--logo-width2) * var(--logo-count));
                width: var(--logo-width);
                height: var(--logo-height);
                animation-name: slide;
                animation-duration: var(--duration);
                animation-timing-function: linear;
                animation-iteration-count: infinite;
                /* 动态计算出每个logo的动画延时 */
                animation-delay: calc(var(--duration) / var(--logo-count) * (var(--logo-count) - var(--count)) * -1);

                box-sizing: border-box;
                border: 0.9px solid rgba(224, 227, 234, 1);
                border-radius: 12px;
                background-size: 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                text-align: center;


                .row2-item-in{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                    width: 190px;
                    max-width: 8vw;
                    height: 72px;
                    border-radius: 12px;
                    background-position: center;

                }
                .row2-item1{
                    background-image: url("../assets/home/row2_1.svg");
                }
                .row2-item2{
                    background-image: url("../assets/home/row2_2.svg");
                }
                .row2-item3{
                    background-image: url("../assets/home/row2_3.svg");
                }
                .row2-item4{
                    background-image: url("../assets/home/row2_4.svg");
                }
                .row2-item5{
                    background-image: url("../assets/home/row2_5.svg");
                }
                .row2-item6{
                    background-image: url("../assets/home/row2_6.svg");
                }
                .row2-item7{
                    background-image: url("../assets/home/row2_7.svg");
                }
                .row2-item8{
                    background-image: url("../assets/home/row2_8.svg");
                }
                .row2-item9{
                    background-image: url("../assets/home/row2_9.svg");
                }
                .row2-item10{
                    background-image: url("../assets/home/row2_19.svg");
                }


            }




        }

        .row2-slide-b {
            --logo-width: 190px;
            --logo-width2: 200px;
            --logo-height: 72px;
            --logo-count: 10;
            --duration: 36s;
            width: 100%;
            margin-inline: auto;
            margin-top: 24px;
            position: relative;
            height: var(--logo-height);
            overflow: hidden;


            @keyframes slide-b {
                to {
                    left: calc(var(--logo-width) * -1);
                }
            }
            .row2-item-b {
                position: absolute;
                left: calc(var(--logo-width2) * var(--logo-count));
                width: var(--logo-width);
                height: var(--logo-height);
                animation-name: slide-b;
                animation-duration: var(--duration);
                animation-timing-function: linear;
                animation-iteration-count: infinite;
                /* 动态计算出每个logo的动画延时 */
                animation-delay: calc(var(--duration) / var(--logo-count) * (var(--logo-count) - var(--count)) * -1);

                box-sizing: border-box;
                border: 0.9px solid rgba(224, 227, 234, 1);
                border-radius: 12px;
                background-size: 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                text-align: center;

                .row2-item-b-in{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                    width: 190px;
                    max-width: 8vw;
                    height: 72px;
                    border-radius: 12px;
                    background-position: center;
                }

                .row2-b-item1{
                    background-image: url("../assets/home/row2_10.svg");
                }
                .row2-b-item2{
                    background-image: url("../assets/home/row2_11.svg");
                }
                .row2-b-item3{
                    background-image: url("../assets/home/row2_12.svg");
                }
                .row2-b-item4{
                    background-image: url("../assets/home/row2_13.svg");
                }
                .row2-b-item5{
                    background-image: url("../assets/home/row2_14.svg");
                }
                .row2-b-item6{
                    background-image: url("../assets/home/row2_15.svg");
                }
                .row2-b-item7{
                    background-image: url("../assets/home/row2_16.svg");
                }
                .row2-b-item8{
                    background-image: url("../assets/home/row2_17.svg");
                }
                .row2-b-item9{
                    background-image: url("../assets/home/row2_18.svg");
                }
                .row2-b-item10{
                    background-image: url("../assets/home/row2_20.svg");
                }
            }



        }

    }
    .about5{
        height: 420px;
        background: #F6F8FF;
        overflow: hidden;
        text-align: center;
        .t1{
            margin-top: 66px;
            font-size: 40px;
            font-weight: bold;
            color: #17171B;
            line-height: 58px;
            text-align: center;
        }
        .t2{
            margin: 0 20px;
            margin-top: 58px;
            display: inline-block;
            position: relative;
            width: 620px;
            height: 140px;
            border-radius: 10px;
            background: #FFFFFF;
            box-shadow: 0px 4px 30px 0px #E8ECF9;
            text-align: left;
            overflow: hidden;
            .t2a{
                margin-top: 34px;
                margin-left: 132px;
                font-size: 24px;
                font-weight: 500;
                line-height: 35px;
                color: #17171B;
            }
            .t2b{
                margin-left: 132px;
                margin-top: 8px;
                font-size: 20px;
                color: #57576C;
                line-height: 28px;
            }
            .about5-icon{
                position: absolute;
                left: 40px;
                top: 34px;
                border-radius: 15px;
                overflow: hidden;
                width: 72px;
                height: 72px;
                background-image: url("../assets/v4/a12.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
            }
            .about5-icon2{
                background-image: url("../assets/v4/a13.png");

            }
        }


    }

}
</style>